/**
 * App.tsx — root component.
 * RouterProvider picks up the router from router.tsx.
 * All providers (QueryClient, theme, toasts) live in main.tsx.
 */

import { RouterProvider } from 'react-router-dom';

import { router } from './router';

export default function App() {
  return <RouterProvider router={router} />;
}
